import { memo } from 'react';
import styled from 'styled-components';
import { Tooltip, Button } from 'antd';
import { ExpandOutlined, CompressOutlined, CloseOutlined } from '@ant-design/icons';
import { useAtomValue, useSetAtom } from 'jotai';
import { availableFormsAtom, selectedFormUUIDAtom } from '../../atoms/CollectFormAtoms';
import CollectFormGrid from './CollectFormGrid';

interface FormListPanelProps {
  onMaximize?: () => void;
  onClose?: () => void;
  isMaximized?: boolean;
}

const FormListPanel = ({
  onMaximize,
  onClose,
  isMaximized,
}: FormListPanelProps) => {
  const availableForms = useAtomValue(availableFormsAtom);
  const setSelectedFormUUID = useSetAtom(selectedFormUUIDAtom);

  const handleFormSelect = (formUuid: string) => {
    setSelectedFormUUID(formUuid);
  };

  const handleGoToFormsTab = () => {
    setSelectedFormUUID(null);
  };

  return (
    <Container>
      <ControlRow>
        <LeftControls>
          <RecordCount>Chọn biểu mẫu để xem dữ liệu</RecordCount>
        </LeftControls>
        <ControlActions>
          {onMaximize && (
            <Tooltip title={isMaximized ? 'Thu nhỏ' : 'Phóng to'}>
              <Button
                type="text"
                size="small"
                icon={isMaximized ? <CompressOutlined /> : <ExpandOutlined />}
                onClick={onMaximize}
              />
            </Tooltip>
          )}
          {onClose && (
            <Tooltip title="Đóng">
              <Button type="text" size="small" icon={<CloseOutlined />} onClick={onClose} />
            </Tooltip>
          )}
        </ControlActions>
      </ControlRow>
      <CollectFormGrid
        forms={availableForms}
        onSelectForm={handleFormSelect}
        onGoToFormsTab={handleGoToFormsTab}
      />
    </Container>
  );
};

export default memo(FormListPanel);

const Container = styled.div`
  padding: 6px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ControlRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 6px;
`;

const RecordCount = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
`;

const LeftControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ControlActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
